import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  viewRoleController,
  subAdminModuleListController,
  adminTypeListController,
} from "../../services/subAdminServices/subAdminServices";
import { toast } from "react-toastify";
import { Checkbox, FormControlLabel } from "@mui/material";
import useFullPageLoader from "../../hooks/useFullPageLoader";

const ViewRoleDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [roleDetails, setRoleDetails] = useState({});
  const [moduleName, setModuleName] = useState([]);
  const [permissionArray, setPermissionArray] = useState([]);
  const [loader, show, hide] = useFullPageLoader();

  const fetchModuleList = async () => {
    try {
      show();
      const response = await subAdminModuleListController();
      if (response?.data?.code === 200) {
        setModuleName((prevModuleName) => [
          ...prevModuleName,
          ...(response?.data?.data || []).map((item) => ({
            ...item,
            access: item.access.split(",").map(Number), // Convert to numbers
          })),
        ]);
        hide();
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
        hide();
      }
    } catch (e) {
      console.log("Error fetching module list:", e.message);
      hide();
    }
  };

  const fetchRoleDetails = async () => {
    try {
      show();
      const response = await viewRoleController(id);
      if (response?.data?.code === 200) {
        setRoleDetails(response?.data?.data);
        
        // Process moduleAccess data to create permissionArray
        const moduleAccessData = response?.data?.data?.moduleAccess || [];
        setPermissionArray(
          moduleAccessData.reduce((acc, { accessId, moduleId }) => {
            const existingModule = acc.find(
              (item) => item.moduleKey === moduleId
            );

            if (existingModule) {
              existingModule.accessKey.push(Number(accessId));
            } else {
              acc.push({
                moduleKey: moduleId,
                accessKey: [Number(accessId)],
              });
            }

            return acc;
          }, [])
        );
        hide();
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
        hide();
      }
    } catch (e) {
      console.log("Error fetching role details:", e.message);
      hide();
    }
  };

  useEffect(() => {
    fetchModuleList();
    fetchRoleDetails();
  }, [id]);

  return (
    <div className="main-panel">
      <div className="content-wrapper">
        <div className="page-header">
          <h2 className="page-title">
            <span
              className="page-title-icon bg-gradient-primary text-white me-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <i className="mdi mdi-chevron-double-left"></i>
            </span>
            View Role Details
          </h2>
          <nav aria-label="breadcrumb"></nav>
        </div>
        {loader}
        <div className="wrap_Add_retailer">
          <div className="col-md- grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <form className="form-sample">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Role Name
                        </label>
                        <div className="col-sm-9 text-start">
                          <input
                            type="text"
                            className="form-control"
                            value={roleDetails.role || ""}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row mt-4">
                    <div className="col-12">
                    </div>
                    {moduleName.map((item, index) => (
                      <React.Fragment key={++index}>
                        <div className="col-6 mb-4 text-start">
                          <h5>{item?.name}</h5>
                          <div className="permission-checkboxes">
                            {item.access.map((accessId) => {
                              const labelValue =
                                accessId === 1
                                  ? "Add"
                                  : accessId === 2
                                  ? "Edit"
                                  : accessId === 3
                                  ? "View"
                                  : accessId === 4
                                  ? "Delete"
                                  : accessId === 5
                                  ? "Status"
                                  : accessId === 6
                                  ? "Request"
                                  : null;

                              return (
                                <FormControlLabel
                                  key={accessId}
                                  label={labelValue}
                                  checked={permissionArray.some(
                                    (module) =>
                                      module &&
                                      module.moduleKey === item.id &&
                                      module.accessKey &&
                                      module.accessKey.includes(
                                        Number(accessId)
                                      )
                                  )}
                                  control={<Checkbox />}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRoleDetails;